import { render, staticRenderFns } from "./ViewDepartmentUnit.vue?vue&type=template&id=52e5ffd6&scoped=true"
import script from "./ViewDepartmentUnit.vue?vue&type=script&lang=js"
export * from "./ViewDepartmentUnit.vue?vue&type=script&lang=js"
import style0 from "./ViewDepartmentUnit.vue?vue&type=style&index=0&id=52e5ffd6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e5ffd6",
  null
  
)

export default component.exports